import { FC } from "react";

import { TaskDriverStatusEnum } from "@/domain/models/common";

import { useUpdateServiceMutation } from "../data/mutations/serviceMutations";
import { useUpdateTaskMutation } from "../data/mutations/taskMutations";
import { JobServiceTaskBaseType } from "../domain/task";
import { DriverStepScreenWrapper } from "./DriverStepScreenWrapper";

const DriverWaitBinFilled: FC<JobServiceTaskBaseType> = ({
  jobId,
  serviceId,
  taskId,
}) => {
  const {
    mutate: updateService,
    isPending: isUpdatingService,
    variables,
  } = useUpdateServiceMutation();
  const { mutate: updateTask, isPending: isUpdatingTask } =
    useUpdateTaskMutation();

  const onNextClick = () => {
    updateService({
      serviceId,
      jobId,
      driverFlowStatus: TaskDriverStatusEnum.CATEGORIZE_BIN_CONTENTS,
    });

    updateTask({
      jobId,
      serviceId,
      taskId,
      driverFlowStatus: TaskDriverStatusEnum.CATEGORIZE_BIN_CONTENTS,
    });
  };

  const isLoading = isUpdatingService || isUpdatingTask;

  const isNextButtonLoading =
    isLoading &&
    variables?.driverFlowStatus ===
      TaskDriverStatusEnum.CATEGORIZE_BIN_CONTENTS;

  const isPreviousButtonLoading =
    isLoading &&
    variables?.driverFlowStatus ===
      TaskDriverStatusEnum.SELECTING_BIN_FOR_SERVICE;

  const goToPreviousStep = () => {
    updateService({
      jobId,
      serviceId,
      driverFlowStatus: TaskDriverStatusEnum.SELECTING_BIN_FOR_SERVICE,
    });

    updateTask({
      jobId,
      serviceId,
      taskId,
      driverFlowStatus: TaskDriverStatusEnum.SELECTING_BIN_FOR_SERVICE,
    });
  };

  return (
    <DriverStepScreenWrapper
      jobId={jobId}
      serviceId={serviceId}
      taskId={taskId}
      title="driver_wait_bin_filled.title"
      nextButtonTitle="driver_wait_bin_filled.next_button"
      isNextButtonLoading={isNextButtonLoading}
      onNextButtonClick={onNextClick}
      previousButtonTitle="driver_wait_bin_filled.back_button"
      onPreviousButtonClick={goToPreviousStep}
      isPreviousButtonLoading={isPreviousButtonLoading}
    />
  );
};

export { DriverWaitBinFilled };
